import React from 'react'

import TrackEvents from '../../atoms/TrackEvents/TrackEvents'

import { URLS } from '../../../constants'

import styles from './Header.module.scss'
import crossIcon from '../../static/cross.svg'

export const ImgLink = ({
  className,
  href,
  title,
  src,
  alt,
  imgStyle,
  width,
}) => (
  <a href={href} title={title} className={className}>
    <img src={src} alt={alt} style={imgStyle} width={width} />
  </a>
)

const MobileNavBtn = ({ isActive, onClick }) => (
  <button
    className={styles.mobileNavBtn}
    title="menu"
    aria-controls="menu"
    aria-expanded={isActive}
    onClick={onClick}
    type="button"
  >
    {!isActive && (
      <>
        {'Menu '}
        <span aria-hidden="true">≡</span>
      </>
    )}
    {isActive && (
      <>
        {'Close menu '}
        <img src={crossIcon} aria-hidden="true" alt="close icon" />
      </>
    )}
  </button>
)

const MobileMenu = ({ onClick }) => (
  <>
    <nav className={styles.mobileMenu}>
      <ul role="menu">
        <li role="menuitem" className={styles.mobileMenuLink}>
          <a href="/about">About</a>
        </li>
        <li role="menuitem" className={styles.mobileMenuLink}>
          <a href="/blog">Blog</a>
        </li>
        <li role="menuitem" className={styles.mobileMenuLink}>
          <a href="/community">Community</a>
        </li>
        <li
          role="menuitem"
          className={[styles.mobileMenuLink, styles.navLink].join(' ')}
        >
          Help
        </li>
      </ul>
      <TrackEvents category="conversion" action="download app" label="header">
        <a href={URLS.ADJUST_BOTH_STORE} className={styles.mobileSignUpBtn}>
          Sign up
        </a>
      </TrackEvents>
    </nav>
  </>
)

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isMobileMenuActive: false }
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    this.setState(prevState => ({
      isMobileMenuActive: !prevState.isMobileMenuActive,
    }))
  }

  render() {
    const { isMobileMenuActive } = this.state
    return (
      <header
        className={`${styles.headerWrapper} ${isMobileMenuActive &&
          styles.fixed}`}
      >
        <div className={styles.contentContainer}>
          <div className={styles.flexContainer}>
            <div className={styles.logoFlexContainer}>
              <a href="/" className={styles.mobileMenuLogo}>
                Monzo – The bank of the future
              </a>
            </div>
            <nav className={styles.primaryNavFlexContainer}>
              <ul role="menu">
                <li role="menuitem">
                  <a href="/about">About</a>
                </li>
                <li role="menuitem">
                  <a href="/blog">Blog</a>
                </li>
                <li role="menuitem">
                  <a href="/community">Community</a>
                </li>
                <li role="menuitem">
                  <span>Help</span>
                </li>
              </ul>
            </nav>

            <div className={styles.secondaryNavFlexContainer}>
              <TrackEvents
                category="conversion"
                action="download app"
                label="header"
              >
                <a href={URLS.ADJUST_BOTH_STORE} className={styles.button}>
                  Sign up
                </a>
              </TrackEvents>
            </div>
            <MobileNavBtn
              isActive={isMobileMenuActive}
              onClick={() =>
                this.setState(prevState => ({
                  isMobileMenuActive: !prevState.isMobileMenuActive,
                }))
              }
            />
          </div>
          {isMobileMenuActive && <MobileMenu onClick={this.toggleMenu} />}
        </div>
      </header>
    )
  }
}

export default Header
